import "./Composition.scss";
import { composition } from "./Composition";
import Lines from "../../components/Lines";
import TableComponent from "../../components/Table/TableComponent";

const Composition = () => {
    const columns = ["S.No", "Name", "Designation", "MemberShip"];

    return (
        <section className="compositionMainContainer">
            <header>
                <h2>IQAC Composition</h2>
                    <span className="lines-parent">
                        <Lines color="#0D553A" count={25} skewDeg={65} fontSize={2.3} spacing={0.5} skewParent={-30}/>
                    </span>
            </header>
            <article className="compositionPageTableParent">
                <TableComponent columns={columns} data={composition} />
            </article>
        </section>
    );
};

export default Composition;
